import Chart from 'react-google-charts';
import { isNotEmpty } from '../../common/util.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { useState } from 'react';

const LineChart = (props: any) => {
  const options = { legend: {position: 'top', alignment: 'center'}, pointSize: 5};
  const [chart1Data, setChart1Data] = useState(props.data1);
  const [chart2Data, setChart2Data] = useState(props.data2);

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    let type = (event.target as HTMLInputElement).value;
    if('Order' === type) {
      setChart1Data(props.data1);
    } else if ('Asin' === type) {
      setChart1Data(props.data3);
    } else if('Total' === type) {
      setChart1Data(props.data4);
    } else {
      setChart1Data(props.data6);
    }
  }
  
  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    let type = (event.target as HTMLInputElement).value;
    if('Value' === type) {
      setChart2Data(props.data2);
    } else if ('Cumulative' === type) {
      setChart2Data(props.data5);
    }
  }

  return (
    <div style={{ fontFamily: 'sans-serif !important'}}>
      {isNotEmpty(props.data3) && isNotEmpty(props.data4) && <Grid container justifyContent="center" alignItems="center">
        <FormControl>
          <RadioGroup defaultValue="Order" name="chart1" row={true} onChange={handleChange1}>
            <FormControlLabel value="Order" control={<Radio />} label="Order #" />
            <FormControlLabel value="Asin" control={<Radio />} label="ASIN #" />
            <FormControlLabel value="Total" control={<Radio />} label="Total #" />
            <FormControlLabel value="Ad Cost" control={<Radio />} label="Ad Cost" />
          </RadioGroup>
        </FormControl>
      </Grid>}
      <Chart chartType="LineChart" width="1000px" data={chart1Data} options={options} legendToggle={true}/>
      {isNotEmpty(props.data2) && isNotEmpty(props.data5) && <Grid container justifyContent="center" alignItems="center">
        <FormControl>
          <RadioGroup defaultValue="Value" name="chart2" row={true} onChange={handleChange2}>
            <FormControlLabel value="Value" control={<Radio />} label="Value" />
            <FormControlLabel value="Cumulative" control={<Radio />} label="Cumulative" />
          </RadioGroup>
        </FormControl>
      </Grid>}
      {isNotEmpty(props.data2) && isNotEmpty(props.data5) && <Chart chartType="LineChart" width="1000px" 
       data={chart2Data} options={options} legendToggle={true}/>}
    </div>
    );
}

export default LineChart;